export const LX_CONFIG = {
    COUPON_CARD_MV: 'b_daodian_lowcode_7x1artbl_mv',
    // 券卡片曝光
    COUPON_CARD_MC: 'b_daodian_lowcode_i89ivbm4_mc',
    // 券卡片领取
    CLAIM_ALL_MC: 'b_daodian_lowcode_61v5qxsw_mc',
    // 一键领取点击
    CLAIM_ALL_MV: 'b_daodian_lowcode_4qu64fd3_mv' // 一键领取区域曝光
};
